import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';

@Component({
    selector: 'jobs-assets',
    templateUrl: './jobs-assets.component.html',
    styleUrls: ['./jobs-assets.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class JobsAssetsComponent extends BaseGridUIComponent<v_DispatchAssignmentBus, null, DispatchesService>  {

    constructor(svc_data: DispatchesService, globals: GlobalsService) {
        super(globals);
        this.svc_data = svc_data;
  }
}
